let theme = {
  primary: '#007bff',
}

export default theme
